<template>
  <div fluid 
      >
    <v-card
      ref="sidebar"
      class="pa-2 sidebar-container d-flex flex-column "
      tile
      :style="{'min-height': `${display.side.height+7}px`}"
    >
      <v-flex>
        <v-tabs color="purple" v-model="localtab">
          <v-tab :key="TabView.OVERVIEW_TAB" :href="'#'+TabView.OVERVIEW_TAB" @click="set_tab(TabView.OVERVIEW_TAB)">Overview</v-tab>
          <v-tab :key="TabView.DETAIL_TAB" :href="'#'+TabView.DETAIL_TAB" @click="set_tab(TabView.DETAIL_TAB)">Detail</v-tab>
          <v-tab :key="TabView.CONTROL_TAB" :href="'#'+TabView.CONTROL_TAB" @click="set_tab(TabView.CONTROL_TAB)">Filter</v-tab>
          <v-tab :key="TabView.HISTORY_TAB" :href="'#'+TabView.HISTORY_TAB" @click="set_tab(TabView.HISTORY_TAB)">History</v-tab>
        </v-tabs>
        <v-tabs-items :value="localtab">
          <v-tab-item :value="TabView.OVERVIEW_TAB">
            <overview-panel></overview-panel>
          </v-tab-item>
          <v-tab-item :value="TabView.DETAIL_TAB">
            <detail-panel></detail-panel>
          </v-tab-item>
          <v-tab-item :value="TabView.CONTROL_TAB">
            <attrs-panel></attrs-panel>
          </v-tab-item>
          <v-tab-item :value="TabView.HISTORY_TAB">
            <history-panel></history-panel>
          </v-tab-item>
        </v-tabs-items>
      </v-flex>
      <v-spacer></v-spacer>
      <div style="height: 1px; background: black;"></div>
      <div class="align-self-end" :style="{'width':'100%'}">
        <!-- List of the current prefix of the selected node-->
        <div>
          <span v-for="(item, index) in current_sequence" :key='index' :style="{ width: 'max-content', height: 'max-content', background: color_map[item] || color_map.default, color: (is_color_dark[item] ? 'white' : 'black')}" class="in_sequence" @click="on_remove_sequence(index)">{{item}}</span>
          <div>
            <v-row v-if="current_sequence.length > 0" style="margin: 0px;">
              <v-col cols="6">
                <v-btn id="alignBy" @click="on_align_by" :style="{margin: '10px'}">
                  Align by Selection
                </v-btn>
              </v-col>
              <v-col cols="3" fluid>
                <v-text-field :disabled="alignByLast" v-model="alignByID" type="number" label="Occurence #" min="1" @input="updateAlignOccurence" id="alignByID"/>
              </v-col>
              <v-col cols="3"><v-checkbox v-model="alignByLast" label="Last" id="checkboxLast" :off-icon="mdiCheckboxBlankOutline" :on-icon="mdiCheckboxMarked"/></v-col>
            </v-row>
            <v-btn id="cancel" @click="on_exit_sequence" v-if="view_type == ViewType.SEQUENCE_VIEW_TYPE" :style="{ margin:'10px'}">
              Cancel Alignment
            </v-btn>
          </div>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import DetailPanel from "./Sidebar/Detail"
import AttrsPanel from "./Sidebar/Attributes"
import OverviewPanel from "./Sidebar/Overview"
import HistoryPanel from "./Sidebar/History"
import { mapGetters, mapMutations, mapActions } from "vuex"
import { ViewType, TabView } from '../Config'
import { mdiCheckboxMarked, mdiCheckboxBlankOutline } from '@/svgIcons'

export default {
  components: {
    DetailPanel,
    AttrsPanel,
    OverviewPanel,
    HistoryPanel,
  },
  data () {
    return {
      ViewType: ViewType,
      TabView: TabView,
      localtab: undefined,
      alignByID: 1,
      alignByLast: false,
      mdiCheckboxMarked: mdiCheckboxMarked,
      mdiCheckboxBlankOutline: mdiCheckboxBlankOutline,
    }
  },
  watch: {
    tab (newval) {
      if (newval !== this.localtab)  this.localtab = newval
    },
    align_sequence_by() {
      if(this.align_sequence_by >= 0){
        this.alignByID   = this.align_sequence_by+1;
        this.alignByLast = false;
      }
      else
        this.alignByLast = true;
    },
  },
  mounted() {
    this.localtab = this.tab
  },
  computed: {
    ...mapGetters(['tab', 'display', 'color_map', 'view_type', 'current_sequence', 'is_color_dark', 'align_sequence_by']),
  },
  methods: {
    ...mapMutations(['set_tab']),
    ...mapActions(['set_align_sequence']),
    on_remove_sequence(index){
        this.current_sequence.splice(index, 1);
    },
    on_align_by(){
      this.set_align_sequence({sequence: this.current_sequence, nOccurence: (this.alignByLast ? -1 : (this.alignByID - 1))});
    },
    on_exit_sequence() {
      this.set_align_sequence({sequence: [], nOccurence: 0});
    },
    updateAlignOccurence() {
      if(isNaN(this.alignByID))
        return;
      let id = parseInt(this.alignByID);
      if(isNaN(id))
        return;
      if(id < 1)
        this.alignByID = 1;
    },
  }
};
</script>
<style>
.in_sequence{
    padding:2px;
    margin:2px;
}
</style>
